import { THEME } from '@lyon/utils/theme';
import { BlockOverrides } from 'baseui/block';

export const NAME: BlockOverrides = {
  Block: {
    style: {
      marginTop: 0,
      marginBottom: 0,
      display: '-webkit-box',
      WebkitLineClamp: 1,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      cursor: 'pointer',
      marginLeft: '16px',
    },
  },
};

export const POINTS: BlockOverrides = {
  Block: {
    style: {
      marginTop: 0,
      marginBottom: 0,
      marginLeft: '16px',
      color: THEME.colors.mono600,
    },
  },
};

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr auto',
      gridColumnGap: '64px',
      alignItems: 'center',
    },
  },
};

export const ICON: BlockOverrides = {
  Block: {
    style: {
      color: THEME.colors.positive400,
    },
  },
};

export const DELETE: BlockOverrides = {
  Block: {
    style: {
      color: THEME.colors.negative400,
    },
  },
};
